import type { ISegmentNameModal } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { SegmentModal } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-modals/SegmentModal";
import type { FC } from "react";
import { getHasSegmentShareClaim } from "app/services/segments/SegmentsUtils";

export const SegmentNameModal: FC<ISegmentNameModal> = ({
    isOpen,
    isDisabledConfirmButton,
    onConfirm,
    onModalClose,
    modalConfirmButtonLabel,
    children,
}) => {
    return (
        <SegmentModal
            onModalClose={onModalClose}
            isOpen={isOpen}
            isDisabledConfirmButton={isDisabledConfirmButton}
            onConfirm={onConfirm}
            modalTitle={"segment.wizard.new.create.modal.title"}
            modalText={"segment.wizard.new.create.modal.label.text"}
            modalHint={"segment.wizard.new.create.modal.label.text.hint"}
            modalDisclaimer={
                getHasSegmentShareClaim()
                    ? "segment.wizard.new.create.modal.shared.disclaimer.private"
                    : "segment.wizard.new.create.modal.shared.disclaimer.public"
            }
            modalConfirmButtonLabel={modalConfirmButtonLabel}
        >
            {children}
        </SegmentModal>
    );
};
